import EducationList from './EducationList'

import EducationItemForm from './EducationItemForm'
import EducationItemPreview from './EducationItemPreview'

export default EducationList
export { EducationItemForm, EducationItemPreview }
